import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  dashboardPage: {},
  logo: {
    width: 180,
  },
  layout: {
    display: 'flex',
    width: '86vw',
    height: '80vh',
    justifyContent: 'space-between',
    flexDirection: 'row',
    borderRadius: ' 2px',
    border: '1px solid rgba(0, 0, 0, 0.10)',
    background:
      'linear-gradient(180deg, rgba(255, 255, 255, 0.90) 27.49%, rgba(255, 255, 255, 0.00) 65%)',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      overflow: 'scroll',
      justifyContent: 'space-between',
      paddingBottom: '30px',
      paddingTop: '20px',
      height: '100%',
    },
  },
  layoutDark: {
    display: 'flex',
    width: '86vw',
    height: '80vh',
    justifyContent: 'space-between',
    flexDirection: 'row',
    borderRadius: ' 2px',
    border: '1px solid rgba(0, 0, 0, 0.10)',
    background:
      'linear-gradient(180deg, #212121 10%, rgba(33, 33, 33, 0.40) 100%)',
    // 'linear-gradient(180deg, rgba(255, 255, 255, 0.90) 76%, rgba(255, 255, 255, 0.00) 100%)',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column-reverse',
      overflow: 'scroll',
      justifyContent: 'space-between',
      paddingBottom: '30px',
      paddingTop: '20px',
      height: '100%',
    },
  },
  content: {
    width: '100%',
    display: 'flex',
    justifyContent: 'start',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2),
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(1),
      overflow: 'scroll',
    },
  },
  contentDark: {
    width: '100%',
    display: 'flex',
    justifyContent: 'start',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(1),
    overflow: 'hidden',
    // backgroundColor: '#1b1b1b',
    color: '#C7C5C5',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(1),
      overflow: 'none',
    },
  },
  contentProfile: {
    width: '30%',
    display: 'flex',
    justifyContent: 'start',
    flexDirection: 'column',
    borderLeft: '1px solid rgba(0, 0, 0, 0.10)',
    borderImage:
      'linear-gradient(to bottom,  rgba(102, 102, 102, 0.2), rgba(0, 0, 0, 0.0)) 1 100%',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingTop: '35px',
      borderLeft: 'none',
      borderTop: '1px solid rgba(0, 0, 0, 0.10)',
    },
  },
  contentProfileDark: {
    width: '30%',
    display: 'flex',
    justifyContent: 'start',
    flexDirection: 'column',
    borderLeft: '1px solid rgba(255, 255, 255, 0.10)',
    borderImage:
      'linear-gradient(to bottom,  rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.0)) 1 100%',
    padding: theme.spacing(1),
    // backgroundColor: '#1b1b1b',
    color: '#C7C5C5',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      paddingTop: '35px',

      borderLeft: 'none',
      borderTop: '1px solid rgba(255, 255, 255, 0.10)',
    },
  },
}));
